// Module
var code = "<div class=row> <div class=col-xs-11> <h4 translate>{{ 'summary.info.' + type + '.list' }}</h4> </div> <div class=col-xs-1> <a name=openModal ng-click=openModal() href=\"\" tooltip=\"{{ :: 'summary.info.violation.modal.open' | translate}}\"> <span class=menu-icon><i class=\"fa fa-edit\"></i></span> </a> </div> </div> ";
// Exports
module.exports = code;